<template>
  <b-tooltip
    :show="true"
    :placement="placement"
    :target="target"
    triggers="manual"
    custom-class="free-months-tooltip"
    :noninteractive="true"
    :title="$t('subscription.two-month-free')"
  />
</template>

<script>
import { BTooltip } from 'bootstrap-vue'

export default {
  name: 'CanGetExtraFreeTooltip',
  components: {
    BTooltip,
  },
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
  },
}
</script>

<style lang="scss">
.free-months-tooltip {
  &.bs-tooltip-bottom {
    .arrow:before {
      border-bottom-color: var(--secondary);
    }
  }

  &.bs-tooltip-left {
    .arrow:before {
      border-left-color: var(--secondary);
    }
  }

  &.bs-tooltip-right {
    .arrow:before {
      border-right-color: var(--secondary);
    }
  }

  .tooltip-inner {
    background: var(--secondary);
    color: #ffffff;
  }
}
</style>
